import { List } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { IndexListItem } from 'components/styles_components/list';
import ListHeader from 'components/inspection_result/index/list_header';
import ListItem from 'components/inspection_result/index/list_item';
import LoaderContainer from 'components/layout/loader_container';
import InfoContainer from 'components/info_container';

const Index = ({ inspectionResults, sortBy, onSortChange, loading }) => {
  return (
    <List>
      <ListHeader sortBy={sortBy} onSortChange={onSortChange} />
      <LoaderContainer loading={loading} wrap={false} keepRenderedContent={true}>
        {inspectionResults.inspectionResults.map((inspectionResult) => (
          <ListItem key={inspectionResult.id} inspectionResult={inspectionResult} />
        ))}
        {inspectionResults.inspectionResults.length === 0 && (
          <IndexListItem>
            <InfoContainer>
              <FormattedMessage id="inspection.results.empty" />
            </InfoContainer>
          </IndexListItem>
        )}
      </LoaderContainer>
    </List>
  );
};

export default Index;
